import styles from './Loader.module.scss';

export const Loader = ({ style }) => {
  return (
    <div style={style} className={styles.Loader} />
  );
};
